// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Z_OK","title":"Header_title__-LJnB","side":"Header_side__80rdU"};